// extracted by css-extract-rspack-plugin
export default {"checkbox":"vKj8QJ","checkbox-label":"MnY7XR","checkboxLabel":"MnY7XR"};